import React from 'react'
import LIVE_PERMISSIONS from 'live/services/authorization'
import ServiceLocator from 'live/services/service-locator'
import { openModal } from '../AnnotationModal'
import WellConfigTab from '../config/WellConfigTab'
import { LiveApi } from 'live/lib/api'
import SourceConfig from '../config/SourceConfig'

try {
    ServiceLocator.getService('asset-tab-service').then(service => {
        service.register({
            step: 'ilt-config',
            assetType: 'wells',
            label: 'ILT Program',
            shouldHide: false,
            body: props => (
                <React.Suspense fallback={'loading'}>
                    <WellConfigTab {...props} />
                </React.Suspense>
            )
        })
    })

    LiveApi.Extension.configuration.entries.register({
        name: 'OFFSHORE ILT Programs Source',
        area: 'aof-ilt-programs-source',
        group: 'static-data',
        url: '/#/config/aof-ilt-programs-source',
        component: props => (
            <React.Suspense fallback={'loading'}>
                <SourceConfig {...props} company="offshore" />
            </React.Suspense>
        ),
        permissions: [LIVE_PERMISSIONS.ADMIN]
    })

    LiveApi.Extension.configuration.entries.register({
        name: 'ONSHORE ILT Programs Source',
        area: 'aon-ilt-programs-source',
        group: 'static-data',
        url: '/#/config/aon-ilt-programs-source',
        component: props => (
            <React.Suspense fallback={'loading'}>
                <SourceConfig {...props} company="onshore" />
            </React.Suspense>
        ),
        permissions: [LIVE_PERMISSIONS.ADMIN]
    })
} catch (e) {
    console.error(e)
}